// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.need-help-form-container .need-help-inner-form-container {
  width: 100%;
}
.need-help-form-container .need-help-inner-form-container mat-form-field {
  width: 100%;
  margin: 0;
}

.need-help-error-style {
  margin: 0px 30px;
  width: 230px;
}

.need-help-right-align {
  float: right;
  margin: 5px;
}

.Need-help-form-radio-group {
  display: flex;
  flex-direction: column;
  margin: 15px 0;
}

.Need-help-form-radio-button {
  margin: 3px;
}

.need-help-margin {
  margin: 30px 24px 0px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/need-help/need-help.component.scss"],"names":[],"mappings":"AAEI;EACI,WAAA;AADR;AAGQ;EACI,WAAA;EACA,SAAA;AADZ;;AAOE;EACE,gBAAA;EACA,YAAA;AAJJ;;AAOE;EACE,YAAA;EACA,WAAA;AAJJ;;AAOE;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AAJJ;;AAOE;EACE,WAAA;AAJJ;;AAOE;EACI,yBAAA;AAJN","sourcesContent":["$form-field-margin: 10px;\n.need-help-form-container{\n    .need-help-inner-form-container{\n        width:100%;\n\n        mat-form-field{\n            width:100%;\n            margin:0\n\n        }\n    }\n}\n\n  .need-help-error-style {\n    margin: 0px 30px;\n    width: 230px;\n  }\n\n  .need-help-right-align {\n    float: right;\n    margin:5px;\n  }\n\n  .Need-help-form-radio-group {\n    display: flex;\n    flex-direction: column;\n    margin: 15px 0;\n  }\n  \n  .Need-help-form-radio-button {\n    margin: 3px;\n  }\n\n  .need-help-margin{\n      margin: 30px 24px 0px 0px;\n  }\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
